/**
 * Currency input formatting utilities.
 * Formats numeric input with thousand separators (Indonesian format: dots)
 * while keeping the raw numeric value accessible.
 */

/**
 * Format a number string with thousand separators (dot).
 * Example: "150000" → "150.000"
 */
export const formatCurrencyInput = (value) => {
  if (!value && value !== 0) return '';
  // Remove all non-digit characters
  const digits = String(value).replace(/\D/g, '');
  if (!digits) return '';
  // Format with dots as thousand separator
  return digits.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
};

/**
 * Parse a formatted currency string back to a raw number string.
 * Example: "150.000" → "150000"
 */
export const parseCurrencyInput = (formatted) => {
  if (!formatted) return '';
  return String(formatted).replace(/\./g, '');
};

/**
 * Handle currency input change: strips non-digits and returns raw value.
 */
export const handleCurrencyChange = (inputValue) => {
  return inputValue.replace(/\D/g, '');
};
